import React from 'react';
import { useLang, useT } from '../../../../i18n';
import { exampleDate } from './exampleDate';

// Tableau de bord : le compte à rebours bascule, réponses et budget se remplissent.
const DashboardVisual: React.FC = () => {
  const t = useT();
  const { lang } = useLang();
  return (
    <div className="mk-fv-stage mk-fv-col">
      <div className="mk-fv-countdown">
        <div>
          <span className="mk-fv-countdown-k">{t('Plus que')}</span>
          <span className="mk-fv-countdown-n">
            <span className="mk-fv-flipper">
              <span>{t('J-{n}', { n: 142 })}</span>
              <span>{t('J-{n}', { n: 141 })}</span>
            </span>
          </span>
        </div>
        <span className="mk-fv-countdown-date">{exampleDate(lang, { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}</span>
      </div>
      <div className="mk-fv-kpis">
        <div className="mk-fv-box mk-fv-kpi">
          <span className="mk-fv-k">{t('Réponses')}</span>
          <span className="mk-fv-ring" />
        </div>
        <div className="mk-fv-box mk-fv-kpi">
          <span className="mk-fv-k">{t('Budget')}</span>
          <span className="mk-fv-kpi-n">62 %</span>
          <span className="mk-fv-track">
            <i className="mk-fv-kpi-bar" />
          </span>
        </div>
        <div className="mk-fv-box mk-fv-kpi">
          <span className="mk-fv-k">{t('À faire')}</span>
          <span className="mk-fv-kpi-task">{t('Envoyer les faire-part')}</span>
        </div>
      </div>
    </div>
  );
};

export default DashboardVisual;
